import { render, staticRenderFns } from "./Supervisao.vue?vue&type=template&id=33286ea6"
import script from "./Supervisao.vue?vue&type=script&lang=js"
export * from "./Supervisao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports